import { createSlice } from "@reduxjs/toolkit";
import { FILE_SOURCES } from "layout/documentUploader/constants";

const initialState = {
  activeSource: FILE_SOURCES.COLLECTIONS,
  processingFiles: false,
  files: [],
};

export const chooseFilesModalSlice = createSlice({
  name: "chooseFilesModal",
  initialState,
  reducers: {
    setActiveSource: (state, action) => {
      state.activeSource = action.payload;
    },
    setProcessingFiles: (state, action) => {
      state.processingFiles = action.payload;
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    resetState: () => initialState,
  },
});

export const { setActiveSource, setProcessingFiles, resetState, setFiles } =
  chooseFilesModalSlice.actions;

export default chooseFilesModalSlice.reducer;
